/*
 * $Id: $
 *
 * Created on 2/12/2013 by Steve Nelson
 * (C) Copyright 2014 NetScout Systems, Inc.
 * All Rights Reserved.
 *
 * This program is an copyrighted work which is proprietary to NetScout
 * Systems, Inc. and contains confidential information that is not to
 * be reproduced or disclosed to any other person or entity without
 * prior written consent from NetScout Systems, Inc. in each and every
 * instance.
 *
 * WARNING: Unauthorized use, duplication or distribution is strictly
 * prohibited by Federal law. No title to and ownership of this software
 * is hereby transferred.
 *
 * Last change $Date: 5/26/2016 $
 * by $Author: Steve Nelson $
 *
 */

// this file is provided by nG1 team and might be replaced for update later, so disable eslint check
/* eslint-disable */
/* eslint linebreak-style: ["error", "unix"]*/
nsaModuleCommon = {
    broadcast: 'NSABROADCAST',
    callback: 'NSACALLBACK',
    comRouterWindow: null, //the window object where the communication router lives

    /**
     * This is the primary messaging object for the UMC intermodule communications. To make use of it a module would do something like
     * the following sample:
     *
     * var myMessage = new this.Message("<ID of the sender module>", "<ID of the recipient module>");
     *        myMessage.data = "<The message as a string>";
     *        myMessage.send();
     *
     * @param origin id of the sending module
     * @param destination id of the destination module
     * @param data the payload
     * @param subDestn id of a sub module destination if applicable.
     * @return
     */
    Message: function (org, destn, dt, subD, giveFocus) {
        if (dt === null) {
            dt = {};
        }

        if (typeof giveFocus === 'undefined' || giveFocus === null || giveFocus == 'true' || giveFocus === true) {
            giveFocus = true;
        } else {
            giveFocus = false;
        }

        this.origin = org;
        this.destination = destn;
        this.data = dt;
        this.subDestn = subD;
        this.gvFocus = giveFocus;

        var jsonMessage = JSON.stringify(this);

        //a public member send function of the Message object
        this.send = function () {
            var comRouterWin = nsaModuleCommon.getComRouterWindow();
            if (comRouterWin != undefined) {
                if (navigator.userAgent.indexOf('Trident') > -1) {
                    //if any variant of IE
                    if (window.top.opener) {
                        //if running in a child window
                        try {
                            window.top.opener.nsaModuleCommon.routeMessage(
                                this.origin,
                                this.destination,
                                this.data,
                                'true'
                            );
                        } catch (err) {
                            //alert("UMCCOMMON.Message error:  " + err.message);
                        }
                    } else {
                        //if running within the console
                        comRouterWin.nsaModuleCommon.routeMessage(this.origin, this.destination, this.data, 'true');
                    }
                } else {
                    //if not IE
                    comRouterWin.postMessage(jsonMessage, '*');
                }
            } else {
                console.log('nGp is not launched by nG1');
            }
        };

        this.wrapperSend = function () {
            var comRouterWin = nsaModuleCommon.getComRouterWindow();
            if (comRouterWin !== undefined) {
                comRouterWin.postMessage(jsonMessage, '*');
            }
        };
    },

    Callback: function (ID) {
        var callback = new this.Message(ID, this.callback, this.callback);
        callback.send();
    },

    /*
     * Initialize listeners for the messaging
     */
    InitCommunication: function () {
        //verify that recieveMessage is implemented if it isn't things won't work so give a warning
        if (typeof recieveMessage != 'function') {
            alert('recieveMessage not implemented');
        }

        if (window.addEventListener) {
            // all browsers except IE before version 9
            window.addEventListener('message', this.OnMessage, false);
        } else {
            if (window.attachEvent) {
                // IE before version 9
                window.attachEvent('onmessage', this.OnMessage); // Internet Explorer from version 8
            }
        }
    },

    /*
     * On the message event call the recieveMessage function which the module should have implemented.
     * If it hasn't been implemented an alert is thrown during the init.
     */
    OnMessage: function (event) {
        var msgObj = {};
        if (event.data && event.data !== '') {
            //for IE 11
            try {
                msgObj = JSON.parse(event.data);
            } catch (err) {
                console.log(`Cannot covert the event data to json: ${err}`);
                return;
            }
        }
        var message = msgObj.data;
        var subModule = msgObj.subDestn;
        try {
            if (typeof subModule === 'undefined') {
                //recieveMessage should be implemented by the module
                recieveMessage(msgObj.destination, message, msgObj.origin, msgObj.subDestn);
            } else {
                var subModuleElement = document.getElementById(subModule);

                if (typeof subModuleElement !== 'undefined' && subModuleElement !== null) {
                    //if there's a sub module try to send it the message
                    subModuleElement.contentWindow.recieveMessage(
                        msgObj.destination,
                        message,
                        msgObj.origin,
                        msgObj.subDestn
                    );
                } else {
                    //otherwise send message to the parent
                    recieveMessage(msgObj.destination, message, msgObj.origin, msgObj.subDestn);
                }
            }
        } catch (err) {
            alert('this error: ' + err.message);
        }
    },

    /*
     * Calls nGeniusONE to display a dialog with a recognized Xerror message and title. Translations are
     * provided by the UMC Xerror resource bundles for known errors.
     */
    showXerror: function (id, type) {
        nsaModuleCommon.getComRouterWindow().netscout.nsa.modulecontroller.callNSAAlert(id, type);
    },

    /*
     * Deprecated call do not use.
     */
    InitKeyboardController: function () {}, //end initKeyboardController

    /**
     * Initiate all communication between console and module
     * Should be initiated at the load of all iframe bodys
     */
    onLoadCommunication: function () {
        nsaModuleCommon.InitCommunication();
    }, //end onLoadAll

    getComRouterWindow: function () {
        let comRouter_window = window.opener;
        return comRouter_window;
    },
}; //end of netscout.nsa.moduleCommon

module.exports = nsaModuleCommon;
